import React, {
  useState,
  createContext,
  useContext,
  useEffect,
  useRef
} from "react";
import { AgentContext } from "../../Pages/Agent/AgentFormsAndServices";
import { FormsResponseContext } from "../../Pages/Agent/AgentFormsAndServices";
import { IdleCodeContext } from "../../Pages/Agent/AgentHomePage";
import { IoIosArrowUp } from "react-icons/io";
import { FaExternalLinkAlt } from "react-icons/fa";

import InputGroup from "react-bootstrap/InputGroup";
import Loading from "../Loading";
import apis, * as api from "../../api/api";
import FormRowData from "./FormRowData";
import { FaPhoneVolume, FaPause } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { Form, Toast } from "react-bootstrap";
import CustomDropDown from "./CustomDropDown";
import genesysConfig from "../../config/genesysClientConfig";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";
import { Snackbar, Alert } from "@mui/material";
import Spinner from "react-bootstrap/Spinner";

// import FormRowData from "./FormRowData";
export const MyContext = createContext([]);
const FormsView = ({ processIsCreated }) => {
  const { language } = useLanguage();
  const pageTitle = "FormsView";
  const [snackbarData, setSnackbarData] = useState({ show: false });
  const [errorSnackbarData, setErrorSnackbarData] = useState({ show: false });
  const [isLoading, setLoading] = useState(false);
  const [runningForms, setRunningForms] = useState([]);
  const [historyForms, setHistoryForms] = useState([]);
  const [inboundMap, setInboundMap] = useState(new Map());
  const [outboundMap, setOutboundMap] = useState(new Map());
  const [flatAgentServices, setFlatAgentServices] = useState([]);
  const [totalDurations, setTotalDurations] = useState(0);
  const [totalActivities, setTotalActivities] = useState(0);
  const [openPhoneMenu, setOpenPhoneMenu] = useState(true);
  const [presencesState, setPresencesState] = useState([]);
  const [presencesApi, setPresencesApi] = useState({});
  const [conversationList, setConversationList] = useState({});
  const [agentInfoState, setAgentInfoState] = useState({ id: "" });
  const agentInfoRef = useRef(agentInfoState);
  const [contactList, setContactList] = useState([]);
  const [lobsList, setLobsList] = useState([]);
  const [outboundLines, setOutboundLines] = useState([]);
  const [lineOneNumber, setLineOneNumber] = useState("");
  const [lineTwoNumber, setLineTwoNumber] = useState("");
  const [lineOneVdn, setLineOneVdn] = useState("");
  const [callerId, setCallerId] = useState("");
  const [lineTwoVdn, setLineTwoVdn] = useState("");
  const [tenantSettings, setTenantSettings] = useState({});
  const [currentHoldState, setCurrentHoldState] = useState(false);
  const [processDataCache, setProcessDataCache] = useState({});
  const [isVoiceChannel, setIsVoiceChannel] = useState(false);
  const [inboundQueueCalledName, setInboundQueueCalledName] = useState("");
  const [inboundCallingNumber, setInboundCallingNumber] = useState("");
  const [inboundCustomer, setInboundCustomer] = useState("");
  //TODO : set this flag dynamically according to admin settings to activate or deactivate the Business Area optional feature on phone module
  const [lobsAreActivated, setLobsAreActivated] = useState(true);
  const [chosenLob, setChosenLob] = useState("");

  // house DB state variables
  const [houseDID, setHouseDID] = useState("");

  // jira state variables
  const [jiraUrl, setJiraUrl] = useState(null);
  const [jiraTicketNumber, setJiraTicketNumber] = useState(null);
  const [jiraPrefix, setJiraPrefix] = useState(null);

  const today = new Date();
  const dd = today.getDate();
  const mm = today.getMonth() + 1; // Months are zero-indexed
  const yyyy = today.getFullYear();
  let exampleStartTime = new Date("2023-11-12T22:30:00");
  let exampleEndTime = new Date();
  const [ongoingWarmTransfer, setOngoingWarmTransfer] = useState(false);
  const ongoingWarmTransferRef = useRef(ongoingWarmTransfer);

  useEffect(() => {
    ongoingWarmTransferRef.current = ongoingWarmTransfer;
  }, [ongoingWarmTransfer]);
  const [consulteeConnected, setConsulteeConnected] = useState(false);
  const consulteeConnectedRef = useRef(consulteeConnected);

  useEffect(() => {
    consulteeConnectedRef.current = consulteeConnected;
  }, [consulteeConnected]);
  const [consultCallData, setConsultCallData] = useState({});
  const [consulteeId, setConsulteeId] = useState();
  const [consultHeld, setConsultHeld] = useState(false);
  const [mergeCalls, setMergeCalls] = useState(false);
  exampleStartTime.setHours(22, 30, 0);
  exampleEndTime.setHours(23, 30, 0);
  const myFormEnded = {
    id: 2,
    name: "my form",
    service: "myService",
    type: "OFFLINE ACTIVITY",
    info: "",
    line: "",
    startTime: exampleStartTime,
    endTime: exampleEndTime,
    duration: "",
    options: ""
  };

  const myFormRunning = {
    id: 1,
    name: "my form",
    service: "myService",
    type: "OFFLINE ACTIVITY",
    info: "",
    line: "",
    startTime: exampleStartTime,
    endTime: "",
    duration: "",
    options: ""
  };
  // const myPastFroms = [
  //   myFormEnded,
  //   myFormEnded,
  //   myFormEnded,
  //   myFormEnded,
  //   myFormEnded,
  // ];
  // const myCurrentForms = [myFormRunning];
  const formattedDate = `${dd}.${mm}.${yyyy}`;
  const [ongoingCallBool, setOngoingCallBool] = useState(false);

  const handleEndTime = (id, Date, isPausing) => {
    //used to set the end time for the process , if the process is paused then endtime date argument will carry the actual endtime , if the process is resumed then the date object contain empty date

    swapCurrentRunning(id, Date, isPausing);
  };
  const pad = (timeValue) => {
    return timeValue.toString().padStart(2, "0");
  };
  function formatDateToUTCString(date) {
    return (
      date.getUTCFullYear() +
      "-" +
      String(date.getUTCMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getUTCDate()).padStart(2, "0") +
      " " +
      String(date.getUTCHours()).padStart(2, "0") +
      ":" +
      String(date.getUTCMinutes()).padStart(2, "0") +
      ":" +
      String(date.getUTCSeconds()).padStart(2, "0")
    );
  }

  function getStartAndEndUTC() {
    const now = new Date();
    const startOfDay = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        0,
        0,
        0
      )
    );
    const endOfDay = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        23,
        59,
        59
      )
    );

    return {
      startDate: formatDateToUTCString(startOfDay),
      endDate: formatDateToUTCString(endOfDay)
    };
  }
  function handleFetchAllProcesses() {
    setLoading(true);
    const { startDate, endDate } = getStartAndEndUTC();
    console.log(startDate);
    console.log(endDate);
    api.getAllProcesss(startDate, endDate).then((response) => {
      setRunningCallProcessDetails([]);
      setLoading(false);
      const { current, history } = response.data.object;
      console.log(response.data.object);
      setRunningForms(current);
      setHistoryForms(history.reverse());
      handleCalculateDurations([...current, ...history]);
      setTotalActivities(current.length + history.length);
    });
  }

  function openJira() {
    console.log("opening jira ticket, with tenant settings: ", tenantSettings);

    if (tenantSettings.jiraSettingDto.isJiraPopUp) {
      console.log("auto open jira ticket is enabled");
      window.open(
        jiraUrl,
        "Jira Ticket",
        "width=1200,height=800,top=200,left=300"
      );
    }
  }

  useEffect(() => {
    // setting the call object to the call object of the first paricipant
    let call = conversationData?.calls[0];
    console.log("call is : ", call);
    if (call.state !== "disconnected" && call.state !== "terminated") {
      if (currentHoldState) {
        //pause current call process and save it's id for later in local storage to be resumed
        let currentProcess = runningForms[0];
        newPauseCurrentProccess(false, []);
        console.log(
          "this is the line that changes heldprocessid",
          call,
          "current process is: ",
          currentProcess
        );
        if (currentProcess !== undefined) {
          localStorage.setItem("heldProcessId", currentProcess?.processId);
        }
      } else {
        // call is resumed so resume the process stored in local storage
        let processId = localStorage.getItem("heldProcessId");
        if (processId) {
          // checks if a processid is already stored and not null
          // do not resume process if it was transferred
          if (call.disconnectType === "transferred") return;
          else if (!ongoingWarmTransfer) {
            resumeProcess(processId);
          }
        } else {
          console.log("*& held process id was removed");
        }
      }
    }
  }, [currentHoldState]);

  useEffect(() => {
    //fetching forms and proccesses to be displayed in the vie
    handleFetchAllProcesses();
  }, [processIsCreated]);
  useEffect(() => {
    //fetching and setting vdn maps to make it easy to fetch corresponding form to the queue id in inbound and outbound calls
    api.getAgentInboundVdns().then((res) => {
      console.log("inbound vdns are ", res.data.object);
      let inboundVdns = res.data.object;
      let newInboundMap = new Map();
      inboundVdns?.forEach((inVdn) => {
        newInboundMap.set(inVdn.vdn, {
          id: inVdn.inboundVdnId,
          name: inVdn.name,
          lineOfBusiness: inVdn.lineOfBusiness
        });
      });
      setInboundMap(newInboundMap);
      console.log(newInboundMap);
    });
    api.getAgentOutboundLines().then((res) => {
      console.log("outbound vdns are ", res.data.object);
      setOutboundLines(res.data.object);
      let outboundVdns = res.data.object;
      let newOutboundMap = new Map();
      outboundVdns.forEach((outVdn) => {
        newOutboundMap.set(outVdn.vdn, {
          name: outVdn.name,
          phoneNumber: outVdn.phoneNumber
        });
      });
      setOutboundMap(newOutboundMap);
      setLineOneVdn(res.data.object.find((v) => v.isDefault == true)?.vdn);
      setCallerId(
        res.data.object.find((v) => v.isDefault == true)?.phoneNumber
      );
      console.log(newOutboundMap);
    });

    api.getAllAgentServicesFlat().then((res) => {
      setFlatAgentServices(res.data.object);
    });

    api.getAgentTenantSettingsById().then((res) => {
      setTenantSettings(res.data.object);
    });
  }, []);

  useEffect(() => {
    // fetching the contact list for the agent call module
    api.getContactList().then((response) => {
      console.log("contacts are", response.data.object);
      setContactList(response.data.object);
    });
  }, []);
  useEffect(() => {
    // fetching the line of businesses for the agent call module
    api.getAllAgentLobs().then((response) => {
      console.log("lobs are", response.data.object);
      setLobsList(response.data.object);
    });
  }, []);
  const myFunc = useContext(AgentContext);
  const formsResponse = useContext(FormsResponseContext);
  useEffect(() => {
    console.log("responses in forms view: ", formsResponse);
  }, [formsResponse]);

  async function testFunc() {
    asyncPauseCurrentProccess();
  }
  useEffect(() => {
    window.addEventListener(
      "beforeunload",
      async (event) => {
        event.preventDefault(); // Delay reload temporarily
        try {
          // const response = await fetch('/your-api-endpoint');
          // Process response data
          const response = await testFunc();
        } catch (error) {
          // Handle errors

          console.log("error in pausing on reload ", error);
        } finally {
          window.removeEventListener("beforeunload", () => {});
          event.returnValue = ""; // Allow reload to proceed
        }
      },
      { capture: true }
    );
  }, [runningForms]);

  function handleDeleteAll() {
    let newArray = [...historyForms];
    newArray.forEach((proc) => {
      api.deleteProcessById(proc.processId).then(() => {
        console.log("deleted process : ", proc.processId);
        newArray = newArray.filter((e) => e.processId != proc.processId);
        console.log(newArray);
        if (newArray.length == 0) {
          console.log("deleted all processes");
          handleFetchAllProcesses();
        }
      });
    });
  }
  function newPauseCurrentProccess(isFinalized) {
    //pause current form
    let currentRunningProcess = runningForms[0];
    //pause current process
    //TODO: pause or end form based on isFinalized , pass it to api
    if (currentRunningProcess) {
      console.log(
        "pausing with data: ",
        currentRunningProcess.allProcessDetails
      );
      api
        .endProcess(
          currentRunningProcess.processId,
          false,
          currentRunningProcess.allProcessDetails
        )
        .then(() => {
          console.log("paused process : ", currentRunningProcess.processId);
          handleFetchAllProcesses();
        });
    }
  }
  function showSuccessMessage() {
    setSnackbarData({
      ...snackbarData,
      message: "Form saved successfully!",
      show: true,
      severity: "success"
    });
  }
  function pauseCurrentProccess(isFinalized, stateProcessDetails) {
    //pause current form
    let currentRunningProcess = runningForms[0];
    //pause current process
    //TODO: pause or end form based on isFinalized , pass it to api
    if (currentRunningProcess) {
      console.log(
        "pausing with data: ",
        currentRunningProcess.allProcessDetails
      );
      api
        .endProcess(
          currentRunningProcess.processId,
          false,
          currentRunningProcess.allProcessDetails
        )
        .then(() => {
          console.log("paused process : ", currentRunningProcess.processId);
          handleFetchAllProcesses();
        });
    }
  }
  async function asyncPauseCurrentProccess(isFinalized) {
    //pause current form
    let currentRunningProcess = runningForms[0];
    //pause current process
    //TODO: pause or end form based on isFinalized , pass it to api
    try {
      if (currentRunningProcess) {
        console.log(
          "pausing with data: ",
          currentRunningProcess.allProcessDetails
        );
        await api
          .endProcess(
            currentRunningProcess.processId,
            false,
            currentRunningProcess.allProcessDetails
          )
          .then((res) => {
            console.log("paused process : ", currentRunningProcess.processId);
            // handleFetchAllProcesses();
            return res;
          });
      } else {
        return null;
      }
    } catch (err) {
      console.error("Error pausing/finalizing process:", err);
      return null;
    }
  }

  function resumeProcess(processId) {
    let currentRunningProcess = runningForms[0];
    //pause current process
    if (currentRunningProcess && !ongoingWarmTransfer) {
      if (
        currentRunningProcess.processType.name === "Incoming Call" ||
        currentRunningProcess.processType.name === "Outgoing Call"
      ) {
        console.warn("Resume function is the one talking: ", processId);
        //show error message
        setErrorSnackbarData({
          ...errorSnackbarData,
          show: true,
          severity: "error"
        });
      } else {
        api
          .endProcess(
            currentRunningProcess.processId,
            false,
            currentRunningProcess.allProcessDetails
          )
          .then(() => {
            console.log("paused process : ", currentRunningProcess.processId);
            api.continueProcess(processId).then(() => {
              console.log("process continued: ", processId);
              handleFetchAllProcesses();
            });
          });
      }
    } else {
      api.continueProcess(processId).then(() => {
        console.log("process continued: ", processId);
        handleFetchAllProcesses();
      });
    }
    // resume selected process by using the api

    //pause current process
  }

  function swapCurrentRunning(processId, Date, isPausing) {
    console.log("swapping current with: ", processId);
    let runningArray = [...runningForms]; //making old copy of current running form
    let historyArray = [...historyForms];
    if (runningArray[0] && runningArray[0].processId === processId) {
      let currentRunningProcess = runningArray[0];
      api
        .endProcess(currentRunningProcess.processId, false, [
          {
            sectionFieldId: 1,
            value: ""
          }
        ])
        .then(() => {
          console.log("paused process : ", currentRunningProcess.processId);
        });
      if (isPausing) {
        historyArray.unshift(...runningArray);
        runningArray = [];
        console.log("new current: ", runningArray);
        console.log("new history: ", historyArray);
      }
    }

    const objWithIdIndex = historyArray.findIndex(
      (obj) => obj.processId === processId
    );
    if (objWithIdIndex > -1) {
      let removedForm = historyArray[objWithIdIndex];
      console.log("form to be removed from history to current: ", removedForm);
      historyArray.splice(objWithIdIndex, 1);
      removedForm = {
        ...removedForm,
        allProcessTimes: [{ ...removedForm.allProcessTimes[0], endTime: Date }]
      };
      historyArray.unshift(...runningArray);
      runningArray = [removedForm];
      console.log("new current: ", runningArray);
      console.log("new history: ", historyArray);
    }
    setRunningForms(runningArray);
    setHistoryForms(historyArray);
  }

  const filterRistrictedForms = (formsArray) => {
    if (tenantSettings.isRestrictedMode) {
      return formsArray.filter((form) => form.isFinalized === false);
    }
    return formsArray;
  };
  // ********** genesys agent sync ********************************
  let connected = false;
  const [conversationData, setConversationData] = useState({
    calls: [{ state: "terminated" }]
  });
  useEffect(() => {
    console.log(
      "##updating hold state to ",
      conversationData?.calls?.at(-1)?.held
    );
    setCurrentHoldState(conversationData?.calls?.at(-1)?.held);
  }, [conversationData?.calls?.at(-1)?.held]);
  // const [runningCallProcess, setRunningCallProcess] = useState(false);
  const [goFetch, setGoFetch] = useState(false);
  let runningCallProcess = false;
  const getMatchingForm = (processType, queueId) => {
    let foundForm = null;
    if (processType === "inbound") {
      if (flatAgentServices) {
        console.log("found forms , searching for qid : ", queueId);
        console.log("flat services", flatAgentServices);
        flatAgentServices.forEach((service) => {
          service.ddiForms.forEach((form) => {
            let numbersArray = form.number
              .split(",")
              .map((number) => number.trim());

            // Convert to numbers
            numbersArray = numbersArray.map(Number);

            console.log(
              "numbers flat are: ",
              numbersArray,
              "inbound map: ",
              inboundMap,
              inboundMap?.get(queueId)?.id,
              numbersArray.includes(inboundMap?.get(queueId)?.id)
            );
            if (numbersArray.includes(inboundMap?.get(queueId)?.id)) {
              foundForm = {
                formId: form.formId,
                serviceId: service.serviceId,
                line: inboundMap.get(queueId).name
              };
              console.log("found matching form : ", foundForm);
              return foundForm;
            }
          });
        });
      } else {
        console.log("no forms found to be searched");
        return foundForm;
      }

      return foundForm;
    } else if (processType === "outbound") {
      if (flatAgentServices) {
        console.log("found forms , searching for qid : ", queueId);
        console.log("flat services", flatAgentServices);
        flatAgentServices.forEach((service) => {
          service.callLineForms.forEach((form) => {
            let vdnsArray = form.name.split(",");
            let queueName = outboundMap.get(queueId);
            console.log("vdns array: ", vdnsArray, "queue name: ", queueName);
            if (queueName && vdnsArray.includes(queueName.name)) {
              foundForm = {
                formId: form.formId,
                serviceId: service.serviceId,
                line: queueName
              };
              console.log("found matching form : ", foundForm);
              return foundForm;
            }
          });
        });
      } else {
        console.log("no forms found to be searched");
        return foundForm;
      }
      return foundForm;
    }
  };

  const formatDuration = (time) => {
    let seconds = Math.floor(time / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };
  const handleCalculateDurations = (searchResult) => {
    let totalDuration = 0;
    searchResult.forEach((process) => {
      if (process.allProcessTimes) {
        console.log("in handle if cond");
        let sumDurations = 0;
        for (let i = 0; i < process.allProcessTimes.length; i++) {
          if (process.allProcessTimes[i].duration) {
            sumDurations = sumDurations + process.allProcessTimes[i].duration;
          }
        }
        totalDuration += sumDurations;
      }
    });
    totalDuration = totalDuration * 1000;
    setTotalDurations(totalDuration);
  };

  function setPresenceInGenesys(presenceId) {
    // used to communicate with genesys api and set the current idle code of the agent
    let presences = window.presences;
    console.log("presences are: ", presences);
    console.log(
      "#### in setpresence , trying setting to : ",
      presenceId,
      "agent info ref is: ",
      agentInfoRef.current
    );

    // check if ref is not null or {id: ''}
    if (!agentInfoRef.current || !agentInfoRef.current.id) {
      console.log("agent info is not set yet in the ref");
      // trace if we can find info in the state
      if (agentInfoState.id) {
        console.log("agent info is set in the state");
        agentInfoRef.current = agentInfoState;
      } else {
        console.log("agent info is not set in the state");
        // fetch agent info
        let usersApi = window.usersApi;
        usersApi.getUsersMe({ expand: ["presence"] }).then((data) => {
          console.log("agent info fetched is: ", data);
          setAgentInfoState((prev) => ({ ...prev, ...data }));
          agentInfoRef.current = { ...data };
        });
      }
    }

    // one more check if it's now set
    if (!agentInfoRef.current || !agentInfoRef.current.id) {
      console.log(
        "agent info is not set yet in the ref after API call, function aborted"
      );
      return;
    }

    if (presences[presenceId]) {
      console.log(
        `Setting presence to ${presences[presenceId].languageLabels.en_US} (${presenceId}), ${agentInfoRef.current.id}`
      );

      // Set presence
      presencesApi
        ?.patchUserPresence(agentInfoRef.current.id, "PURECLOUD", {
          presenceDefinition: { id: presenceId }
        })
        .then(() => {
          console.log("Presence set successfully");
        })
        .catch((err) => console.error(err));
    } else {
      console.log("presence id not found in genesys");
    }
  }

  const parentPresence = useContext(IdleCodeContext);
  useEffect(() => {
    console.log("agent idle codes are : ", parentPresence.agentIdleCodes);
    // checking for intrupptable idle codes
    for (let i = 0; i < parentPresence.agentIdleCodes.length; i++) {
      const idleCode = parentPresence.agentIdleCodes[i];
      if (
        idleCode.ctiId === parentPresence.currentIdleCode &&
        idleCode.stopsActivity
      ) {
        pauseCurrentProccess();
        break;
      }
    }
    console.log(
      "setting genesys presence to: ",
      parentPresence.currentIdleCode
    );
    if (parentPresence.currentIdleCode) {
      setPresenceInGenesys(parentPresence.currentIdleCode);
    }
  }, [parentPresence.currentIdleCode]);

  const [runningCallProcessDetails, setRunningCallProcessDetails] = useState(
    []
  );

  useEffect(() => {
    console.log(
      "Conversation data is :*** ",
      conversationData,
      inboundCallingNumber
    );
    if (conversationData) {
      let call = conversationData.calls?.at(-1);
      console.log("Conversation data call is: ", call);

      // if call.purpose is voicemail, do not process
      if (call?.purpose === "voicemail" || call === undefined) {
        return;
      }

      if (call.state === "connected") {
        // check type of call , if inbound check if queue id matches an already existing form and open it , else open a process without any form
        if (call.direction === "inbound") {
          // match the "conversationData.queueId" with a correct lob
          let queuesLob = inboundMap.get(
            conversationData.queueId
          )?.lineOfBusiness;
          console.log("lobs list: ", lobsList);
          let lob = lobsList.find((lob) => lob.name === queuesLob);
          console.log("lob is: ", lob, "queue name is: ", queuesLob);
          if (lob) {
            console.log("lob found");
            setChosenLob(lob.name);
          }

          // initially we make the data required to just open an empty process
          setOngoingCallBool(true);

          let callPayload = {
            callId: call.id,
            phoneNumber: inboundCallingNumber
              ? inboundCallingNumber.replace("tel:", "")
              : "",
            line: "no line found",
            serviceId: "",
            formId: "",
            processTypeName: "INCOMING_CALL"
          };
          const matchingForm = getMatchingForm(
            "inbound",
            conversationData.queueId
          );
          console.log("matching form here is: ", matchingForm);
          setLineOneVdn(conversationData.queueId);
          if (matchingForm != null) {
            console.log("martching form is not null : ", matchingForm);
            callPayload = {
              ...callPayload,
              serviceId: matchingForm.serviceId,
              formId: matchingForm.formId,
              line: matchingForm.line
            };
          } else {
            console.log("didn't find matching form");
            callPayload = {
              ...callPayload,
              serviceId: "",
              formId: "",
              line: inboundQueueCalledName
            };
          }
          let currentRunningProcess = runningForms[0];
          //pause current process
          console.log(
            "pausing the process that has details of: currentrunningprocess: ",
            currentRunningProcess,
            "runningcallprocessdetials: ",
            runningCallProcessDetails
          );
          if (currentRunningProcess) {
            async function handleProcessFlow() {
              try {
                // Save the data first
                await api.updateProcessDetails(
                  currentRunningProcess.processId,
                  runningCallProcessDetails
                );

                // End the process
                await api.endProcess(
                  currentRunningProcess.processId,
                  false,
                  runningCallProcessDetails
                );

                // Insert the new process
                await api.insertProcess(callPayload);

                // Fetch all processes after successful completion
                handleFetchAllProcesses();
              } catch (error) {
                console.error("Error during process flow:", error);
              }
            }

            // Call the function
            handleProcessFlow();
          } else {
            // verify that call was not previously created

            console.log(
              "call payload is: ",
              callPayload,
              "and running forms are: ",
              runningForms
            );

            if (!runningForms.some((form) => form.callId === call.id)) {
              api
                .insertProcess(callPayload)
                .then(() => {
                  // setRunningCallProcess(true);
                  // runningCallProcess = true ;
                  // setGoFetch(false)
                  handleFetchAllProcesses();
                })
                .catch((error) => {
                  console.log("error creating call : ", error);
                });
            }
          }
          if (inboundCallingNumber) {
            setLineOneNumber(inboundCallingNumber.replace("tel:", ""));
            console.log("line one number is: ", lineOneNumber);
          }

          // check if we are a jira tenant
          openJira();

          // check if we are a house tenant, then check if we should popup

          if (
            tenantSettings.houseSettingDTO.isHouse &&
            tenantSettings.houseSettingDTO.isHousePopUp
          ) {
            console.log("auto open house db is enabled");
            const tenantId = JSON.parse(
              sessionStorage.getItem("userTenant")
            )?.tenantId;
            window.open(
              `/agent/house/did/did=${houseDID}&tenant=${tenantId}`,
              "House Information",
              "width=1000,height=600,top=150,left=150"
            );
          }
        } else if (call.direction === "outbound") {
          // for now we will just open empty process

          let callPayload = {
            callId: call.id,
            phoneNumber: conversationData.address
              ? conversationData.address.replace("tel:", "")
              : "",
            line: "example line",
            serviceId: "",
            formId: "",
            processTypeName: "OUTGOING_CALL"
          };
          console.log("call payload is: ", callPayload);
          const matchingForm = getMatchingForm(
            "outbound",
            conversationData.queueId
          );
          console.log(
            "call payload matching form is: ",
            matchingForm,
            "conv data here is: ",
            conversationData
          );
          console.log("matching form here is: ", matchingForm);
          if (matchingForm != null) {
            console.log("matching form is not null : ", matchingForm);
            callPayload = {
              ...callPayload,
              serviceId: matchingForm.serviceId,
              formId: matchingForm.formId,
              line: outboundLines.find(
                (line) => line.vdn === conversationData.queueId
              )?.name
            };
          } else {
            console.log("didn't find matching form");
            console.log(
              "outbound lines are : ",
              outboundLines,
              outboundLines.find(
                (line) => line.vdn === conversationData.queueId
              )?.name
            );

            callPayload = {
              ...callPayload,
              serviceId: "",
              formId: "",
              line: outboundLines.find(
                (line) => line.vdn === conversationData.queueId
              )?.name
            };
          }

          let currentRunningProcess = runningForms[0];
          //pause current process
          if (currentRunningProcess) {
            api
              .endProcess(
                currentRunningProcess.processId,
                false,
                currentRunningProcess.allProcessDetails
              )
              .then(() => {
                api
                  .insertProcess(callPayload)
                  .then(() => {
                    // setRunningCallProcess(true);
                    // runningCallProcess = true ;
                    // setGoFetch(false)
                    handleFetchAllProcesses();
                  })
                  .catch((error) => {
                    console.log("error creating call : ", error);
                  });
              });
          } else {
            api
              .insertProcess(callPayload)
              .then(() => {
                // setRunningCallProcess(true);
                // runningCallProcess = true ;
                // setGoFetch(false)

                handleFetchAllProcesses();
              })
              .catch((error) => {
                console.log("error creating call : ", error);
              });
          }
        }
      } else if (call.state === "disconnected" || call.state === "terminated") {
        setOngoingCallBool(false);
        // if call ended , initiate end process TODO : adapt it later to handle if state was lost due to refresh
        setHouseDID("");

        setMergeCalls(false);
        let currentRunningProcess = runningForms[0];
        if (
          currentRunningProcess &&
          (currentRunningProcess.processType.name === "Incoming Call" ||
            currentRunningProcess.processType.name === "Outgoing Call") &&
          (call.direction === "inbound" || call.direction === "outbound")
        ) {
          console.log(
            "ending the current call form",
            runningForms,
            runningForms.at(-1).form,
            runningForms.at(-1).form == null
          );

          if (runningForms.at(-1).form == null) {
            // unmatched form, so end process
            api
              .endProcess(runningForms.at(-1).processId, true, [], false)
              .then(() => {
                handleFetchAllProcesses();
              });
            return;
          }

          // gracefully save the data first

          let payloadDetails = runningCallProcessDetails.filter(
            (detail) =>
              detail.value &&
              detail.value !== null &&
              detail.value !== undefined
          );

          console.log(
            "runningCallProcessDetails payload are: ",
            payloadDetails
          );

          api
            .updateProcessDetails(
              currentRunningProcess.processId,
              payloadDetails
            )
            .then(() => {
              // previously, here I was ending the process by myself automatically lama el call t2fel
              // the behavior asked, never end process until the user presses "save"
              // the request now: automatically end processes if it doesn't have a form to fill in!
              /*api
                .endProcessWithoutSaving(
                  currentRunningProcess.processId,
                  true,
                  []
                )
                .then(() => {
                  // setRunningCallProcess(false);
                  // runningCallProcess = false;
                  handleFetchAllProcesses();
                  // change this to transfer the process from a current to a history form
                  // without an api call to not lose any data already saved
                });*/
            });
        } else if (currentHoldState) {
          console.log(
            "ending the call process in case it was paused or put on hold while another offline process was running"
          );
          let processId = localStorage.getItem("heldProcessId");

          setTimeout(async () => {
            try {
              console.log("Resuming process before ending it...");
              await api.continueProcess(processId); // Ensure the process is resumed before ending it

              console.log("Process resumed, now ending...");
              await api.endProcessWithoutSaving(processId, true, []);

              // Refresh process list
              handleFetchAllProcesses();
            } catch (error) {
              console.error("Error handling process resume/end:", error);
            }
          }, 1000);
        } else if (
          (call.state === "terminated" || call.state === "disconnected") &&
          call.disconnectType === "transfer"
        ) {
          console.log("ending the call process in case it was transferred");
          let processId = localStorage.getItem("heldProcessId");
          /*setTimeout(() => {
            api.endProcessWithoutSaving(processId, true, []).then(() => {
              // setRunningCallProcess(false);
              // runningCallProcess = false;
              handleFetchAllProcesses();
            });
          }, 1000);*/
        }
        // resetting conversation data to prevent creating new process after call is transferred
        setConversationData({ calls: [{ state: "terminated" }] });
        //removing any id of previously held process when ending the process
        console.log("&& resetting local storage heldprocessid");
        console.log("&& call data is : ", call);
        localStorage.removeItem("heldProcessId");
      } else if (call.state === "alerting") {
        setLineOneVdn(conversationData.queueId);
        console.log("line one vdn is: ", lineOneVdn);
        // set the caller id in line one
        setLineOneNumber(inboundCallingNumber.replace("tel:", ""));
      }
    }
  }, [conversationData?.calls?.at(-1)?.state]);

  const handlenotification = (params) => {
    try {
      let conversationsApi = window.conversationsApi;
      const notification = JSON.parse(params.data);
      console.log("Parsed notification: ", notification);

      const topicName = notification.topicName.toLowerCase();
      console.log("notification.topicName", topicName);

      // Handle heartbeat or metadata notifications
      if (topicName === "channel.metadata") {
        console.info("Ignoring metadata notification.");
        return;
      }

      // Handle presence updates
      if (topicName === window.userPresenceTopic.toLowerCase()) {
        console.log("Presence notification: ", notification);

        const presenceId = notification.eventBody.presenceDefinition?.id;
        const currentIdleCode = window.presences?.[presenceId];

        if (currentIdleCode?.id) {
          console.log("Setting current idle code to:", currentIdleCode.id);
          parentPresence.setCurrentIdleCode(currentIdleCode.id);
        } else {
          console.warn("Presence ID not found in window.presences.");
        }

        conversationsApi
          .getConversationsCalls()
          .then((data) => {
            data.entities.forEach((call) => {
              call.participants.forEach((participant) => {
                let callId = call.id;
                let participantId = participant.id;

                // 1. Only target current agent participant
                const currentAgentId =
                  agentInfoRef?.current?.id || agentInfoState?.id;
                const isCurrentAgent =
                  participant.purpose === "agent" &&
                  currentAgentId &&
                  participant.user?.id === currentAgentId;
                if (!isCurrentAgent) return;

                // 2. Check if participant is in ACW or wrapup is required
                const isAcwActive =
                  participant.wrapupRequired ||
                  (participant.startAcwTime && !participant.endAcwTime);
                if (!isAcwActive) return;

                // 3. Preserve existing wrapup code if present; fallback to "Agent Idle Change"
                const existingWrapup = participant.wrapup;
                const requestBody = {
                  wrapup:
                    existingWrapup &&
                    (existingWrapup.code ||
                      existingWrapup.id ||
                      existingWrapup.name)
                      ? existingWrapup
                      : {
                          name: "Agent Idle Change",
                          code: "Agent Idle Change"
                        }
                };

                console.log(
                  `Call logs: ${callId} viewed. Agent ACW started at ${participant.startAcwTime} and userId: ${participantId}`
                );
                conversationsApi
                  .patchConversationsCallParticipant(
                    callId,
                    participantId,
                    requestBody
                  )
                  .then(() => {
                    console.log(
                      "Call logs: patchConversationsCallParticipant returned successfully."
                    );
                  })
                  .catch((err) => {
                    console.log(
                      "Call logs: There was a failure calling patchConversationsCallParticipant"
                    );
                    console.error(err);
                  });
              });
            });
          })
          .catch(console.error);

        return;
      }

      // Handle conversation updates
      if (topicName === window.conversationsTopic.toLowerCase()) {
        console.log("Conversation notification: ", notification);

        // root cause fix: do not process callbacks
        const hasCallbacks = notification.eventBody.participants.some(
          (participant) =>
            participant.callbacks && participant.callbacks.length > 0
        );

        console.log("Does the conversation contain callbacks?", hasCallbacks);

        if (hasCallbacks) {
          console.log("Skipping notification due to callbacks.");
          return;
        }

        const newConversationList = { ...conversationList };

        if (isConversationDisconnected(notification.eventBody)) {
          delete newConversationList[notification.eventBody.id];
        } else {
          newConversationList[notification.eventBody.id] =
            notification.eventBody;
        }

        console.log("Updated conversation list: ", newConversationList);
        setConversationList(newConversationList);

        const participants = notification.eventBody.participants || [];
        const agentInfo = agentInfoRef.current;

        // if tenantSetting is a HouseDB, get the house DID from participant data, if not, do nothing
        if (tenantSettings.houseSettingDTO.isHouse) {
          console.log("conversation data at house is: ", participants);
          const houseDID = participants?.find((p) => p.purpose === "customer")
            ?.attributes?.DID_Found;
          if (houseDID) {
            setHouseDID(houseDID);
            console.log("House DID found in participant data is: ", houseDID);
          }
        }

        // check for jira settings
        const ticketNumber = participants.find((p) => p.purpose === "customer")
          ?.attributes?.Ticketnumber;

        const Marketnumber = participants.find((p) => p.purpose === "customer")
        ?.attributes?.Marketnumber;
        const customer = participants.find(p => p.purpose === "customer");

        let ani = null;

        if (customer && customer.address) {
          ani = customer.address.replace("tel:", "");
        }

        console.log("ANI:", ani);
        console.log("participants:", JSON.stringify(participants, null, 2));
        // console.log("convData: " + )

        

        console.log(participants);
        if (
          tenantSettings.jiraSettingDto &&
          tenantSettings.jiraSettingDto.isJira
        ) {
          // interpolate the string from the jira settings + conversationData

          let jiraUrl;
          let jiraCaseCreationUrl = tenantSettings.jiraSettingDto.jiraCaseCreationUrl;
          let jiraPhoneFieldId = tenantSettings.jiraSettingDto.jiraPhoneFieldId;
          let jiraMarketNumberFieldId = tenantSettings.jiraSettingDto.jiraMarketNumberFieldId;

          console.log("tenantSettings: " + tenantSettings.jiraSettingDto)

          if (
            ticketNumber === "0000000"){
            console.log("NO TICKET");
            jiraUrl = `${
              jiraCaseCreationUrl +
              "&" +jiraPhoneFieldId + "=" + ani +
              "&" + jiraMarketNumberFieldId + "=" + Marketnumber
            }`;
            console.log("NO TICKET" + jiraUrl);
          }
          else{
            console.log("TICKET");
            jiraUrl = `${
              tenantSettings.jiraSettingDto.jiraURL +
              tenantSettings.jiraSettingDto.jiraTicketNumberPrefix +
              "-" +
              ticketNumber +
              tenantSettings.jiraSettingDto.jiraSuffix
            }`;
          }
          

          console.log("jira url is: ", jiraUrl);
          setJiraPrefix(tenantSettings.jiraSettingDto.jiraTicketNumberPrefix);
          setJiraTicketNumber(ticketNumber);
          setJiraUrl(jiraUrl);
        }

        // Filter agent participants and inbound call details
        const agentParticipants = participants.filter(
          (participant) =>
            (participant.purpose === "agent" ||
              participant.purpose === "user") &&
            participant.userId === agentInfo?.id
        );

        const inboundQueue = participants.find(
          (participant) => participant.purpose === "acd"
        );

        const inboundCustomer = participants.find(
          (participant) => participant.purpose === "customer"
        );

        if (inboundQueue) {
          setInboundQueueCalledName(inboundQueue.name || "Unknown Queue");
        }

        if (inboundCustomer) {
          setInboundCallingNumber(inboundCustomer.address || "Unknown Address");
          setInboundCustomer(inboundCustomer);
        }

        console.log("Agent participants: ", agentParticipants);

        // Handle the latest agent participant
        const latestAgentParticipant = agentParticipants
          .slice()
          .reverse()
          .find((participant) => participant.userId === agentInfo?.id);

        if (latestAgentParticipant) {
          const latestCall = latestAgentParticipant.calls?.at(-1);

          if (
            latestCall?.state === "disconnected" ||
            latestCall?.state === "terminated"
          ) {
            console.log("Call is disconnected or terminated.");

            setJiraUrl(null);
            setJiraTicketNumber(null);
            setJiraPrefix(null);

            setConversationData({
              id: latestAgentParticipant.id,
              queueId: latestAgentParticipant.queueId,
              address:
                latestCall?.other?.addressNormalized || "Unknown Address",
              calls: latestAgentParticipant.calls,
              currentCallId: notification.eventBody.id
            });
            setHouseDID("");
            return;
          }

          const conversationData = {
            id: latestAgentParticipant.id,
            queueId: latestAgentParticipant.queueId,
            address: latestCall?.other?.addressNormalized || "Unknown Address",
            calls: latestAgentParticipant.calls,
            currentCallId: notification.eventBody.id
          };

          console.log(
            "ongoing warm transfer state is: ",
            ongoingWarmTransferRef.current
          );

          if (
            !ongoingWarmTransferRef.current &&
            !consulteeConnectedRef.current
          ) {
            console.log("Setting conversation data: ", conversationData);
            setConversationData(conversationData);
          }
        } else {
          console.warn("No matching agent participant found.");
          setConversationData({ calls: [{ state: "terminated" }] });
        }

        return;
      }

      console.warn("Unhandled notification topic: ", topicName);
    } catch (error) {
      console.error("Error in handleNotification: ", error);
    }
  };

  function disconnect() {
    // Create request body, only set desired properties
    let body = {
      state: "disconnected"
    };

    setConsulteeConnected(false);

    // Invoke API
    let conversationsApi = window.conversationsApi;
    let callId = conversationData.currentCallId;
    let participantId = conversationData.id;
    conversationsApi
      .patchConversationsCallParticipant(callId, participantId, body)
      .then(() => {
        // Result will be empty here
        console.log("disconnected call with :", callId);
      })
      .catch((err) => console.error(err));
  }
  function hold() {
    // Create request body, only set desired properties
    // Invoke API
    let conversationsApi = window.conversationsApi;
    let callId = conversationData.currentCallId;
    let participantId = conversationData.id;
    let body = {
      held: !currentHoldState
    };

    console.log(
      "holding for the data: participant id: ",
      participantId,
      "call id: ",
      callId
    );

    // Invoke API
    conversationsApi
      .patchConversationsCallParticipant(callId, participantId, body)
      .then(() => {
        setCurrentHoldState(!currentHoldState);
        // Result will be empty here
      })
      .catch((err) => console.error(err));
  }

  async function checkMergeStatus() {
    return mergeCalls;
  }

  // create a function similar to startDirectConsult that transfer the current AGENT
  // to the second AGENT for a warm transfer.
  // after AGENT 1 onboards AGENT 2, the CLIENT is transferred to AGENT 2

  async function startWarmTransferToPhoneNumber() {
    setOngoingWarmTransfer(true);
    let conversationsApi = window.conversationsApi;

    // Retrieve the current call ID from the conversation data
    let callId = conversationData.currentCallId;

    // Get conversation and find customer participant
    let conversationResponse = await conversationsApi.getConversation(callId);
    let participants = conversationResponse.participants;
    let participantId = participants.find((p) => p.purpose === "customer").id;

    // Initiate consult transfer
    let uuiData = `${callerId}`; // "\t+498007968353" strip it to a string with just the +number
    uuiData = uuiData.slice(1);
    //alert(uuiData);
    let uuiBody = {
      callerId: uuiData,
      destination: { address: lineTwoNumber, type: "phoneNumber" },
      speakTo: "DESTINATION"
    };

    let response =
      await conversationsApi.postConversationsCallParticipantConsult(
        callId,
        participantId,
        uuiBody
      );

    console.log(
      "Consult transfer initiated successfully",
      localStorage.getItem("heldProcessId")
    );

    localStorage.setItem(
      "heldProcessIdForTransfer",
      localStorage.getItem("heldProcessId")
    );

    // Hold the customer AFTER initiating consult transfer
    const holdCustomer = async () => {
      try {
        await conversationsApi.patchConversationsCallParticipant(
          callId,
          participantId,
          { held: true }
        );
        setCurrentHoldState(true);
      } catch (err) {
        console.error("Error holding customer:", err);
      }
    };

    await holdCustomer();

    let retryCount = 0;
    const maxRetries = 20;
    const retryInterval = 1000;

    async function checkAndReplaceCall() {
      try {
        let connectedState = await conversationsApi.getConversation(callId);
        console.log("Connected state: ", connectedState);

        // Find the consulted participant
        const consultedParticipant = connectedState.participants.find(
          (p) =>
            p.id === response.destinationParticipantId &&
            p.calls[0]?.state === "connected"
        );

        if (consultedParticipant) {
          console.log(
            "Call connected to the second agent",
            consultedParticipant.calls[0]
          );
          setConsulteeConnected(true);

          setConsultCallData(connectedState);
          setConsulteeId(consultedParticipant.id);

          console.log("Warm transfer completed successfully.");
          return;
        } else {
          console.log("Call not connected to the second agent yet.");
        }
      } catch (error) {
        console.error("Error while checking call state: ", error);
      }

      retryCount++;
      if (retryCount < maxRetries) {
        console.log(`Retrying... (${retryCount}/${maxRetries})`);
        setTimeout(checkAndReplaceCall, retryInterval);
      } else {
        console.error(
          "Max retries reached. Call may not have been connected to the second agent."
        );
        setOngoingWarmTransfer(false);
        setConsulteeConnected(false);

        // Don't automatically unhold here - let the agent decide
        console.log(
          "Transfer failed - agent should manually manage hold state"
        );
        resumeProcess(localStorage.getItem("heldProcessId"));
      }
    }

    // Start the retry loop
    checkAndReplaceCall();
  }

  async function mergeWarmTransferPhoneNumber() {
    let callId = conversationData.currentCallId;
    let conversationsApi = window.conversationsApi;

    // Get conversation and find customer participant
    let conversationResponse = await conversationsApi.getConversation(callId);

    // make it a speak to both situation
    let participants = conversationResponse.participants;
    let participantId = participants.find((p) => p.purpose === "customer").id;
    let uuiData = `${callerId}`;
    let uuiBody = {
      callerId: uuiData,
      destination: { address: lineTwoNumber, type: "phoneNumber" },
      speakTo: "BOTH"
    };

    let response = await conversationsApi
      .postConversationsCallParticipantConsult(callId, participantId, uuiBody)
      .then(() => {
        hold();
        resumeProcess(localStorage.getItem("heldProcessIdForTransfer"));
      });

    console.log("Warm transfer initiated successfully");

    /*
    // the participant to replace in this case is me, agent 1
    let participants = conversationResponse.participants;
    let participantIdSelf = participants.find((p) => p.purpose === "agent").id;

    await conversationsApi
      .postConversationsCallParticipantReplace(callId, participantIdSelf, {
        //destinationParticipantId: response.destinationParticipantId,
        address: lineTwoNumber, // Add the appropriate destination
      })
      .then(() => {
        // when this is successful, we'll need to properly end the process
        console.log("Call merged successfully");

        // End the process
        // resumeProcess(localStorage.getItem("heldProcessIdForTransfer"));
        api
          .continueProcess(localStorage.getItem("heldProcessIdForTransfer"))
          .then(() => {
            // continued the process, now the useeffect should handle the rest
          });
      });*/

    setOngoingWarmTransfer(true);
    setMergeCalls(false);
    setConsulteeConnected(true);
    console.log("Warm transfer completed successfully.");
    return;
  }

  async function stopWarmTransfer() {
    let callId = conversationData.currentCallId;
    let conversationsApi = window.conversationsApi;

    let lastAgent = consulteeId;

    try {
      // 1st API Call: Get conversation details
      const res = await conversationsApi.getConversation(callId);
      console.log(res);

      lastAgent = res.participants.at(-1);
      console.log("last consultee agent: ", lastAgent);

      console.log(
        "consultee id: ",
        consulteeId,
        "call: ",
        conversationData,
        "last agent: ",
        lastAgent
      );

      // 2nd API Call: Waits until the first one completes
      await conversationsApi.patchConversationsCallParticipant(
        callId,
        lastAgent.id,
        {
          state: "disconnected"
        }
      );

      console.log("consultee disconnected");

      setOngoingWarmTransfer(false);
      setMergeCalls(false);
      setConsulteeConnected(false);
    } catch (err) {
      console.error("Error in stopWarmTransfer:", err);
    }
  }

  async function startDirectConsult() {
    let conversationsApi = window.conversationsApi;

    // Retrieve the current call ID from the conversation data
    let callId = conversationData.currentCallId;
    let participantId = conversationData.id;

    console.log("*& logging used data for phone number consult***");
    console.table({
      conversationApi: conversationsApi,
      callId: callId,
      participantId: participantId
    });
    console.log("conversationdata", conversationData);

    // Step 1: Unhold the call first
    hold(); // Execute the hold function

    // Step 2: Proceed to update UUI Data after holding
    setTimeout(async () => {
      try {
        // Retrieve the conversation details, including participants
        let conversationResponse =
          await conversationsApi.getConversation(callId);
        let participants = conversationResponse.participants;

        // Check if there are participants and get the first one
        if (participants && participants.length > 0) {
          let firstParticipant = participants[0];
          let firstParticipantId = firstParticipant.id;

          // Update UUI Data to Include Caller ID
          let uuiData = `${callerId}`; // Set your caller ID here
          let uuiBody = {
            attributes: {
              callerId: uuiData, // Include UUI data (Caller ID)
              address: lineTwoNumber // Include the number to transfer the call to
            }
          };

          // Step 3: Set UUI data for the first participant
          await conversationsApi.patchConversationParticipantAttributes(
            callId,
            firstParticipantId,
            uuiBody
          );
          console.log(
            "UUI data updated successfully for the first participant with Caller ID"
          );

          // Step 4: Verify UUI data immediately after updating
          //verifyUuiData(callId, firstParticipantId);

          // Step 5: Rehold the call
          hold(); // Hold the call again

          // Step 6a: Initiate the transfer after holding with both UUI data and Caller ID
          let body = {
            address: "+1111", // The number to transfer the call to
            attributes: {
              uuiData: uuiData // UUI data (including Caller ID)
            },
            callerId: callerId // Sending the Caller ID directly in the API request
          };

          await conversationsApi.postConversationParticipantReplace(
            callId,
            participantId,
            body
          );

          //Step 6b: transfer to a queue called Cayci dump with the required data and it will transfer on its own
          /*let body = {
            speakTo: "DESTINATION",
            queueId: "d3514253-9943-4a64-8107-218fffdb81ad",
            attributes: {
              uuiData: uuiData, // UUI data (including Caller ID)
            },
            callerId: callerId, // Sending the Caller ID directly in the API request
          };
          await conversationsApi.postConversationParticipantReplace(
            callId,
            participantId,
            body
          );*/

          console.log("Call forwarded successfully with Caller ID in UUI data");
          localStorage.removeItem("heldProcessId");
        } else {
          console.log("No participants found in the call.");
        }
      } catch (err) {
        console.log("There was a failure during the process");
        console.error(err);
      }
    }, 1000); // Adjust the timeout as necessary
  }

  // Function to verify UUI data
  function verifyUuiData(callId) {
    let conversationsApi = window.conversationsApi;
    let olderConversationId = "6846dba7-1fec-46cd-9f05-1dde9fd28eec";
    // fetch older conversation
    conversationsApi.getConversation(olderConversationId).then((response) => {
      console.log(response);
    });
    // Fetch conversation details, including participants
    conversationsApi
      .getConversation(callId)
      .then((response) => {
        console.log(response);
        const participant = response.participants.find(
          (p) => p.id === conversationData.id
        );
        const uuiData = participant?.attributes?.uuiData; // Safely access UUI data
        console.log("Retrieved UUI Data:", uuiData);

        // Set timeouts for further verification
        setTimeout(() => verifyUuiData(callId), 5000); // 5 seconds
      })
      .catch((err) => {
        console.log("Error fetching conversation data");
        console.error(err);
      });
  }

  function startDirectConsultToQueue() {
    // #TODO : add faiure messages for failing to transfer
    //transfers to a queue
    // Grab the first participant, which should be the party we dialed for an outbound call
    // let callId = conversationData.currentCallId;
    // let participantId = conversationData.id;
    let conversationsApi = window.conversationsApi;
    console.debug(conversationList);
    // TODO : check for null callid for transfer to queue
    // let callId = conversationList[Object.keys(conversationList)[0]]?.id;
    let callId = conversationData.currentCallId;
    // let participantId = conversationList[callId].participants.filter(p => p.purpose == "customer")[0].id;
    let participantId = conversationData.id;

    console.log("*&logging used data for consult to queue ***");
    console.table({
      conversationApi: conversationsApi,
      callId: callId,
      participantId: participantId
    });
    console.log("conversationdata", conversationData);
    // Create request body
    let body = {
      queueId: lineTwoNumber
    };

    // Invoke API
    conversationsApi
      .postConversationParticipantReplace(callId, participantId, body)
      .then(() => {
        // $("input#newparticipant").val("");
        console.log("*& forwarded call successfully");
        localStorage.removeItem("heldProcessId");
        // We can ignore the response in this tutorial.
      })
      .catch((err) => {
        console.log(
          "*& There was a failure calling postConversationsCallParticipantConsultQueue"
        );
        console.error(err);
      });
  }
  function startConsult() {
    // #TODO : add faiure messages for failing to transfer
    //transfers to a phone number
    // Grab the first participant, which should be the party we dialed for an outbound call
    // let callId = conversationData.currentCallId;
    // let participantId = conversationData.id;
    let conversationsApi = window.conversationsApi;

    console.debug(conversationList);
    // let callId = conversationList[Object.keys(conversationList)[0]].id;
    let callId = conversationData.currentCallId;
    // let participantId = conversationList[callId].participants.filter(p => p.purpose == "customer")[0].id;
    let participantId = inboundCustomer.id;

    console.log("*& logging used data for phone number consult***");
    console.table({
      conversationApi: conversationsApi,
      callId: callId,
      participantId: participantId
    });
    console.log("conversationdata", conversationData);
    // Create request body
    let body = {
      speakTo: "destination",
      destination: {
        address: lineTwoNumber
        // type: "phoneNumber",
      }
    };

    // Invoke API
    conversationsApi
      .postConversationsCallParticipantConsult(callId, participantId, body)
      .then(() => {
        // $("input#newparticipant").val("");
        console.log("forwarded call successfully");
        // We can ignore the response in this tutorial.
      })
      .catch((err) => {
        // add toast message
        console.log(
          "There was a failure calling postConversationsCallParticipantConsult"
        );
        console.error(err);
      });
  }
  function startConsultToQueue() {
    // #TODO : add faiure messages for failing to transfer
    //transfers to a queue
    // Grab the first participant, which should be the party we dialed for an outbound call
    // let callId = conversationData.currentCallId;
    // let participantId = conversationData.id;
    let conversationsApi = window.conversationsApi;
    console.debug(conversationList);
    // TODO : check for null callid for transfer to queue
    // let callId = conversationList[Object.keys(conversationList)[0]]?.id;
    let callId = conversationData.currentCallId;
    // let participantId = conversationList[callId].participants.filter(p => p.purpose == "customer")[0].id;
    let participantId = inboundCustomer.id;

    console.log("*&logging used data for consult to queue ***");
    console.table({
      conversationApi: conversationsApi,
      callId: callId,
      participantId: participantId
    });
    console.log("conversationdata", conversationData);
    // Create request body
    let body = {
      speakTo: "DESTINATION",
      queueId: lineTwoNumber
    };

    // Invoke API
    conversationsApi
      .postConversationsCallParticipantConsultQueue(callId, participantId, body)
      .then(() => {
        // $("input#newparticipant").val("");
        console.log("*& forwarded call successfully");
        // We can ignore the response in this tutorial.
      })
      .catch((err) => {
        console.log(
          "*& There was a failure calling postConversationsCallParticipantConsultQueue"
        );
        console.error(err);
      });
  }

  // const isConversationDisconnected = (notification) => {
  //   console.log("$$$inside isconvdis $$" , notification);
  //   let isConnected = false;
  //   notification.participants.some((participant) => {
  //     console.log(participant.state);
  //     if (
  //       participant.state !== "disconnected" &&
  //       participant.state !== "terminated"
  //     ) {
  //       //console.log(participant.state);
  //       isConnected = true;
  //       return true;
  //     }
  //   });

  //   return false;
  // };
  function isConversationDisconnected(conversation) {
    // new version of isconvdisconnected
    for (let participant of conversation.participants) {
      for (let call of participant.calls) {
        if (call.state === "disconnected" || call.state === "terminated") {
          console.log("found disconnected or terminated $$");
          return true;
        }
      }
    }
    return false;
  }
  const copyCallPropsToParticipant = (conversation) => {
    conversation.participants.forEach((participant) => {
      if (!participant.calls || participant.calls.length === 0) {
        return;
      }

      participant.ani = participant.calls?.at(-1).self.addressNormalized;
      participant.attributes = participant.additionalProperties;
      participant.confined = participant.calls?.at(-1).confined;
      participant.direction = participant.calls?.at(-1).direction;
      participant.dnis = participant.calls?.at(-1).other.addressNormalized;
      participant.held = participant.calls?.at(-1).held;
      participant.muted = participant.calls?.at(-1).muted;
      participant.provider = participant.calls?.at(-1).provider;
      participant.recording = participant.calls?.at(-1).recording;
      participant.recordingState = participant.calls?.at(-1).recordingState;
      participant.state = participant.calls?.at(-1).state;
      if (participant.userId)
        participant.user = {
          id: participant.userId,
          selfUri: `/api/v2/users/${participant.userId}`
        };
      if (participant.calls?.at(-1).peerId)
        participant.peer = participant.calls?.at(-1).peerId;
    });
  };

  const callNumberFromQueue = () => {
    // this condition to make sure i can only initiate a call from the phone module when no other call is taking place
    if (
      !["contacting", "dialing", "connected"].includes(
        conversationData?.calls?.at(-1)?.state
      )
    ) {
      // Create request body
      let body = {
        callFromQueueId: lineOneVdn,
        phoneNumber: lineOneNumber,
        sessionType: "softphone",
        callerId: callerId
      };

      // Invoke API
      let conversationsApi = window.conversationsApi;
      conversationsApi
        .postConversationsCalls(body)
        .then(() => {
          // Clear dialstring from text box
          console.log("called successfully");
        })
        .catch((err) => console.error(err));
    }
  };
  useEffect(() => {
    console.log("*& new agentinfo in useeffect: ", agentInfoState);
    agentInfoRef.current = agentInfoState;
  }, [agentInfoState]);
  useEffect(() => {
    // Set local vars
    if (tenantSettings.isVoiceChannel) {
      let me, webSocket, notificationChannel;
      const clientId = tenantSettings.clientId;
      const redirectUri = window.location.href.split("?")[0];

      // Set Genesys Cloud objects

      const client = window.client;
      const notificationsApi = window.notificationsApi;

      console.error(window, client, window.client);

      const presenceApi = window.presenceApi;
      const usersApi = window.usersApi;
      const presences = window.presences;
      setPresencesState(presences);
      setPresencesApi(presenceApi);
      //const userPresenceTopic = window.userPresenceTopic;
      // Set Genesys Cloud settings

      console.error(client.setEnvironment, tenantSettings.envUrl);

      client.setEnvironment(tenantSettings.envUrl);
      client.setPersistSettings(true, tenantSettings.appName);

      console.log("logging");

      client
        .loginPKCEGrant(clientId, redirectUri)
        .then(() => {
          console.log("Logged in");

          // Get authenticated user's info
          return usersApi.getUsersMe({ expand: ["presence"] });
        })
        .then((userMe) => {
          console.log("userMe: ", userMe);
          console.log("userMe: ", userMe.username);
          console.log("userMe: ", userMe.id);
          me = userMe;
          // setAgentInfo(userMe);
          console.log("*& setting agent info outside setstate:", userMe);
          setAgentInfoState((prev) => ({ ...prev, ...userMe }));
          // sessionStorage.set("agentInfo" , JSON.stringify(userMe))
          let currentIdleCode = userMe.presence.presenceDefinition.id;
          parentPresence.setCurrentIdleCode(currentIdleCode);

          // Get presences
          return presenceApi.getPresenceDefinitions0();
        })
        .then((presenceListing) => {
          console.log(`Found ${presenceListing.entities.length} presences`);
          console.log("presences :", presenceListing.entities);

          // Create button for each presence
          presenceListing.entities.forEach((presence) => {
            presences[presence.id] = presence;
          });
          setPresencesState(presences);
          // Create notification channel
          return notificationsApi.postNotificationsChannels();
        })
        .then((channel) => {
          console.log("channel: ", channel);
          notificationChannel = channel;

          // Set up web socket
          webSocket = new WebSocket(notificationChannel.connectUri);
          webSocket.onmessage = handlenotification;

          // Subscribe to authenticated user's conversations and presence
          window.conversationsTopic = "v2.users." + me.id + ".conversations";
          window.userPresenceTopic = `v2.users.${me.id}.presence`;

          const body = [
            { id: window.conversationsTopic },
            { id: window.userPresenceTopic }
          ];

          return notificationsApi.putNotificationsChannelSubscriptions(
            notificationChannel.id,
            body
          );
        })
        .then((channel) => {
          console.log("Channel subscriptions set successfully");
        })
        .catch((err) => console.error("genesys auth error: ", err));
    }
  }, [tenantSettings?.isVoiceChannel]);

  // end of genesys admin sync
  const handleCallDuration = (childElapsedTime) => {
    if (["connected"].includes(conversationData?.calls?.at(-1)?.state)) {
    }
  };
  return (
    <div className="main-content" style={{ paddingLeft: "0" }}>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbarData.show}
        autoHideDuration={3000}
        onClose={() => setSnackbarData({ ...snackbarData, show: false })}
      >
        <Alert
          severity="success"
          onClose={() => setSnackbarData({ ...snackbarData, show: false })}
        >
          {strings[pageTitle][language].FormSavedMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={errorSnackbarData.show}
        autoHideDuration={3000}
        onClose={() =>
          setErrorSnackbarData({ ...errorSnackbarData, show: false })
        }
      >
        <Alert
          severity="error"
          onClose={() =>
            setErrorSnackbarData({ ...errorSnackbarData, show: false })
          }
        >
          {strings[pageTitle][language].CantStartForm}
        </Alert>
      </Snackbar>
      <div>
        {isLoading ? <Loading /> : ""}
        {tenantSettings?.isVoiceChannel && (
          <div className="calling-menu" style={{ userSelect: "none" }}>
            <div className="d-flex gap-5 ps-3 pt-1 pb-2 align-items-end justify-content-between">
              <div className="d-flex gap-5  align-items-end">
                <div className="d-flex gap-2 ">
                  <div
                    className="circle-arrow"
                    onClick={() => setOpenPhoneMenu(!openPhoneMenu)}
                  >
                    <IoIosArrowUp
                      size={15}
                      className={
                        !openPhoneMenu
                          ? "phone-menu-arrow rotated"
                          : "phone-menu-arrow"
                      }
                    />
                  </div>
                  <h6>PHONE</h6>
                </div>
                <div>
                  {/* <p className="m-0">LOGIN</p>
                <h6>01010101010</h6> */}
                </div>
                <div>
                  {/* <p className="m-0">STATE</p>
                <h6 style={{ color: "var(--green-accent)" }}>AVAILABLE</h6> */}
                </div>
              </div>
              {lobsAreActivated && (
                <div className="d-flex align-items-center justify-content-center pe-2 gap-2">
                  {tenantSettings.houseSettingDTO?.isHouse &&
                    houseDID !== "" && (
                      <div
                        onClick={() => {
                          const tenantId = JSON.parse(
                            sessionStorage.getItem("userTenant")
                          )?.tenantId;
                          window.open(
                            "/agent/house/did/did=" +
                              houseDID +
                              "&tenant=" +
                              tenantId,
                            "",
                            "width=1000,height=600,top=150,left=150"
                          );
                        }}
                        className="d-flex gap-1"
                        style={{
                          whiteSpace: "nowrap",
                          paddingRight: "10px",
                          cursor: "pointer",
                          _hover: { textDecoration: "underline" },
                          color: "orange"
                        }}
                      >
                        <FaExternalLinkAlt size={15} />
                        <p>Open House</p>
                      </div>
                    )}
                  <p style={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                    LINE OF BUSINESS
                  </p>
                  <Form.Select
                    aria-label="Default select example"
                    onChange={(e) => {
                      setChosenLob(e.target.value);
                    }}
                    value={chosenLob}
                  >
                    {/* <option>Choose ...</option> */}
                    <option value={""}>{"None Specified.."}</option>
                    {lobsList.map((lob) => {
                      return (
                        <option value={lob.name} key={lob.name}>
                          {lob.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                  {/* <button className="button-normal">Wrap-up</button> */}
                </div>
              )}
            </div>

            {openPhoneMenu && (
              <>
                <div
                  className="d-flex call-options"
                  style={{ backgroundColor: "var(--secondary-color)" }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "var(--accent-color-dark)",
                      width: "2%"
                    }}
                  >
                    <FaPhone
                      style={{
                        transform: "rotate(45deg)",
                        color: "var(--accent-color)"
                      }}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center gap-3 ps-4 pt-2 pb-2"
                    style={{ width: "98%" }}
                  >
                    <p style={{ margin: 0 }}>
                      {strings[pageTitle][language].Duration}
                    </p>
                    <p style={{ margin: 0, color: "black" }}>00:00:00</p>
                    <p style={{ margin: 0 }}>
                      {strings[pageTitle][language].PhoneNum}
                    </p>
                    <InputGroup style={{ width: "33%" }}>
                      <Form.Control
                        placeholder={strings[pageTitle][language].PhoneNum}
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                        value={lineOneNumber}
                        onChange={(e) => {
                          setLineOneNumber(e.target.value);
                        }}
                      />

                      <CustomDropDown
                        contactList={
                          lobsAreActivated && chosenLob
                            ? contactList.filter(
                                (contact) =>
                                  contact.lineOfBusiness &&
                                  contact.lineOfBusiness == chosenLob
                              )
                            : contactList.filter(
                                (contact) => !contact.lineOfBusiness
                              )
                        }
                        setParentPhoneNumber={(phone) => {
                          setLineOneNumber(phone);

                          // Find the contact associated with the phone number
                          const selectedContact = contactList.find(
                            (contact) => contact.phone === phone
                          );

                          if (!selectedContact) {
                            console.error(
                              "No contact found for this phone number:",
                              phone
                            );
                            return;
                          }

                          // Log the found contact for debugging
                          console.log("Selected contact:", selectedContact);

                          if (
                            selectedContact.outboundLineName &&
                            selectedContact.outboundLineName !== ""
                          ) {
                            const outboundLine = outboundLines.find(
                              (line) =>
                                line.name === selectedContact.outboundLineName
                            );

                            if (!outboundLine) {
                              console.error(
                                "No outbound line found with name:",
                                selectedContact.outboundLineName
                              );
                              return;
                            }

                            // Log the outbound line for debugging
                            console.log("Outbound line found:", outboundLine);

                            // Update the state with the VDN and phone number
                            setLineOneVdn(outboundLine.vdn);
                            setCallerId(outboundLine.phoneNumber);
                          }
                        }}
                      />
                    </InputGroup>
                    <p style={{ whiteSpace: "nowrap", margin: "0" }}>
                      {strings[pageTitle][language].Line} 1
                    </p>
                    <Form.Select
                      aria-label="Default select example"
                      style={{ width: "33%" }}
                      value={lineOneVdn}
                      onChange={(e) => {
                        if (
                          e.target.value ===
                          JSON.stringify({
                            vdn: "",
                            callerId: ""
                          })
                        ) {
                          setLineOneVdn("");
                          setCallerId("");
                          return;
                        }

                        //const obj = JSON.parse(e.target.value);
                        //console.log(obj, obj.vdn, obj.callerId);
                        setLineOneVdn(e.target.value);

                        // get the caller id of this line
                        const obj = outboundLines.find(
                          (line) => line.vdn === e.target.value
                        );
                        console.log(obj);
                        setCallerId(obj?.phoneNumber ? obj.phoneNumber : "");
                      }}
                    >
                      <option
                        value={JSON.stringify({
                          vdn: "",
                          callerId: ""
                        })}
                      >
                        {strings[pageTitle][language].ChooseLine}
                      </option>
                      {lobsAreActivated && chosenLob
                        ? outboundLines
                            .filter(
                              (line) =>
                                line.lineOfBusiness &&
                                line.lineOfBusiness == chosenLob
                            )
                            .map((line) => {
                              return (
                                <option value={line.vdn}>{line.name}</option>
                              );
                            })
                        : outboundLines
                            .filter((line) => !line.lineOfBusiness)
                            .map((line) => {
                              return (
                                <option value={line.vdn}>{line.name}</option>
                              );
                            })}
                    </Form.Select>
                    <div
                      className={
                        ([
                          "contacting",
                          "dialing",
                          "connected",
                          "consulting"
                        ].includes(conversationData?.calls?.at(-1)?.state) &&
                          !conversationData?.calls?.at(-1)?.held) ||
                        consulteeConnected
                          ? "circle-icon decline-icon"
                          : "circle-icon-disabled"
                      }
                      onClick={() => {
                        if (
                          ([
                            "contacting",
                            "dialing",
                            "connected",
                            "consulting"
                          ].includes(conversationData?.calls?.at(-1)?.state) &&
                            !conversationData?.calls?.at(-1)?.held) ||
                          consulteeConnected
                        ) {
                          disconnect();
                          setMergeCalls(false);
                          setConsulteeConnected(false);
                          setOngoingWarmTransfer(false);
                        }
                      }}
                    >
                      <FaPhone style={{ transform: "rotate(135deg)" }} />
                    </div>
                    <div
                      onClick={() => {
                        if (lineOneNumber && lineOneVdn) {
                          callNumberFromQueue();
                        }
                      }}
                      className={
                        lineOneNumber &&
                        lineOneVdn &&
                        lineOneVdn !== "" &&
                        !["contacting", "dialing", "connected"].includes(
                          conversationData?.calls?.at(-1)?.state
                        )
                          ? "circle-icon answer-icon"
                          : "circle-icon-disabled"
                      }
                    >
                      <FaPhone style={{ transform: "rotate(45deg)" }} />
                    </div>
                    <div
                      className={
                        ["connected"].includes(
                          conversationData?.calls?.at(-1)?.state
                        )
                          ? currentHoldState
                            ? "circle-icon pause-icon-active"
                            : "circle-icon pause-icon"
                          : "circle-icon-disabled"
                      }
                      onClick={() => {
                        if (
                          ["connected"].includes(
                            conversationData?.calls?.at(-1)?.state
                          )
                        ) {
                          hold();
                        }
                      }}
                    >
                      <FaPause />
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex call-options "
                  style={{
                    backgroundColor: "var(--secondary-color)",
                    borderTop: "1px solid var(--agent-teriary-color)",
                    borderBottom: "1px solid var(--accent-color)",
                    width: "100%"
                  }}
                >
                  {!currentHoldState && !ongoingWarmTransfer && (
                    <div className="disabled-div"></div>
                  )}
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "var(--accent-color-dark)",
                      width: "2%"
                    }}
                  >
                    <FaPhone
                      style={{
                        transform: "rotate(45deg)",
                        color: "var(--accent-color)"
                      }}
                    />
                  </div>
                  <div
                    className="d-flex align-items-center gap-3 ps-4 pt-2 pb-2"
                    style={{ width: "98%" }}
                  >
                    <p style={{ margin: 0 }}>
                      {strings[pageTitle][language].Duration}
                    </p>
                    <p style={{ margin: 0, color: "black" }}>00:00:00</p>
                    <p style={{ margin: 0 }}>
                      {strings[pageTitle][language].PhoneNum}
                    </p>
                    <InputGroup style={{ width: "33%" }}>
                      <Form.Control
                        placeholder={strings[pageTitle][language].PhoneNum}
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                        value={lineTwoNumber}
                        onChange={(e) => {
                          setLineTwoNumber(e.target.value);
                        }}
                      />

                      <CustomDropDown
                        contactList={
                          lobsAreActivated && chosenLob
                            ? contactList.filter(
                                (contact) =>
                                  contact.lineOfBusiness &&
                                  contact.lineOfBusiness == chosenLob
                              )
                            : contactList.filter(
                                (contact) => !contact.lineOfBusiness
                              )
                        }
                        setParentPhoneNumber={(phone) => {
                          setLineTwoNumber(phone);
                          // Find the contact associated with the phone number
                          const selectedContact = contactList.find(
                            (contact) => contact.phone === phone
                          );

                          if (!selectedContact) {
                            console.error(
                              "No contact found for this phone number:",
                              phone
                            );
                            return;
                          }

                          // Log the found contact for debugging
                          console.log("Selected contact:", selectedContact);

                          if (
                            selectedContact.outboundLineName &&
                            selectedContact.outboundLineName !== ""
                          ) {
                            const outboundLine = outboundLines.find(
                              (line) =>
                                line.name === selectedContact.outboundLineName
                            );

                            if (!outboundLine) {
                              console.error(
                                "No outbound line found with name:",
                                selectedContact.outboundLineName
                              );
                              return;
                            }

                            // Log the outbound line for debugging
                            console.log("Outbound line found:", outboundLine);

                            // Update the state with the VDN and phone number

                            setCallerId(outboundLine.phoneNumber);
                            setLineTwoVdn(outboundLine.vdn);
                          } else if (selectedContact.outboundLineName == "") {
                            setCallerId("");
                            setLineTwoVdn("");
                          }
                        }}
                      />
                    </InputGroup>
                    <p style={{ whiteSpace: "nowrap", margin: "0" }}>
                      {strings[pageTitle][language].Line} 2
                    </p>
                    <Form.Select
                      aria-label="Default select example"
                      style={{ width: "33%" }}
                      value={lineTwoVdn}
                      onChange={(e) => {
                        if (e.target.value == "") {
                          setCallerId("");
                          setLineTwoVdn("");
                          return;
                        }

                        setLineTwoVdn(e.target.value);
                        // get the caller id of this line
                        const obj = outboundLines.find(
                          (line) => line.vdn === e.target.value
                        );
                        setCallerId(obj.phoneNumber);
                      }}
                    >
                      <option value={""}>
                        {strings[pageTitle][language].ChooseLine}
                      </option>
                      {lobsAreActivated && chosenLob
                        ? outboundLines
                            .filter(
                              (line) =>
                                line.lineOfBusiness &&
                                line.lineOfBusiness == chosenLob
                            )
                            .map((line) => {
                              return (
                                <option value={line.vdn}>{line.name}</option>
                              );
                            })
                        : outboundLines
                            .filter((line) => !line.lineOfBusiness)
                            .map((line) => {
                              return (
                                <option value={line.vdn}>{line.name}</option>
                              );
                            })}
                    </Form.Select>
                  </div>
                  {/* fragment for call controls */}
                  {/* here, we'll have call controls for the second conversation (to consultee) */}
                  {false ? (
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="circle-icon button-icon decline-icon">
                        <FaPhone
                          style={{
                            transform: "rotate(135deg)",
                            marginLeft: "5px"
                          }}
                          onClick={() => {
                            // hang up the consultee, data is available in the state
                            console.log(
                              "hang up the consultee, data is available in the state",
                              consultCallData
                            );

                            let conversationApi = window.conversationsApi;
                            conversationApi
                              .deleteConversationsCall(consultCallData.callId)
                              .then((response) => {
                                console.log("hang up successfully", response);
                              })
                              .catch((error) => {
                                console.error(
                                  "error in hang up the consultee: ",
                                  error
                                );
                              });
                          }}
                        />
                      </div>
                      <div className="circle-icon button-icon hold-icon">
                        <FaPause
                          style={{
                            marginRight: "5px"
                          }}
                          onClick={() => {
                            // hold the consultee
                            let conversationApi = window.conversationsApi;

                            let body = {
                              hold: !consultHeld
                            };

                            let participantId = conversationData.id;

                            conversationApi
                              .patchConversationsCallParticipant(
                                consultCallData.id,
                                consulteeId,
                                body
                              )
                              .then(() => {
                                setConsultHeld(!consultHeld);
                                // Result will be empty here
                              })
                              .catch((err) => console.error(err));
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        onClick={() => {
                          // if !consulteeconnected
                          if (consulteeConnected) {
                            // no cold transfer when consultee connected
                            return;
                          }
                          if (lineTwoNumber) {
                            if (lineTwoNumber.length < 20) {
                              // then it is a phonenumber and will initial normal consult
                              console.log(
                                "transferring to external number: ",
                                lineTwoNumber
                              );
                              startDirectConsult();
                            } else {
                              //then linetwonumber is supposedly a queue id and will try to transfer to queue
                              console.log(
                                "transferring to queue with id: ",
                                lineTwoNumber
                              );
                              startDirectConsultToQueue();
                            }
                          }
                        }}
                        className={
                          lineTwoNumber &&
                          currentHoldState &&
                          !consulteeConnected
                            ? "circle-icon button-icon answer-icon"
                            : "circle-icon button-icon-disabled"
                        }
                      >
                        <FaPhone
                          style={{
                            transform: "rotate(45deg)",
                            marginRight: "5px"
                          }}
                        />
                        {"Cold transfer"}
                      </div>
                      <div
                        onClick={() => {
                          setOngoingWarmTransfer(true);
                          if (consulteeConnected) {
                            // here should be the behaviour of merging the calls
                            console.log("merging calls");
                            mergeWarmTransferPhoneNumber();
                            return;
                          }
                          if (lineTwoNumber) {
                            // then it is a phonenumber/queue and will initiate consult
                            console.log(
                              "transferring to external number: ",
                              lineTwoNumber
                            );
                            //startDirectConsult();
                            startWarmTransferToPhoneNumber();
                          }
                        }}
                        className={
                          lineTwoNumber && currentHoldState
                            ? "circle-icon button-icon answer-icon"
                            : "circle-icon button-icon-disabled"
                        }
                        style={{ paddingLeft: "5px" }}
                      >
                        <FaPhone
                          style={{
                            transform: "rotate(45deg)",
                            marginRight: "5px"
                          }}
                        />
                        {consulteeConnected ? (
                          "Merge"
                        ) : ongoingWarmTransfer ? (
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        ) : (
                          "Consult"
                        )}
                      </div>
                      {consulteeConnected ? (
                        <div
                          onClick={() => {
                            stopWarmTransfer();
                          }}
                          className="circle-icon button-icon answer-icon"
                        >
                          <FaPhone
                            style={{
                              transform: "rotate(135deg)",
                              marginRight: "5px"
                            }}
                          />
                          {"Stop"}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        )}
        <div className="d-flex align-items-start gap-2 justify-content-between pe-5 ">
          <p className="main-content__title">
            {strings[pageTitle][language].Today + " " + formattedDate}{" "}
          </p>

          {!tenantSettings?.isTotalTimeHidden && (
            <div className="d-flex align-items-center gap-2 justify-content-between ">
              <div className="d-flex align-items-start gap-2 justify-content-between me-2 ">
                <p style={{ whiteSpace: "nowrap", margin: "0" }}>
                  {strings[pageTitle][language].DayTotalAct}
                </p>

                <h5 className="total-duration">{totalActivities}</h5>
              </div>
              <div>
                <p style={{ whiteSpace: "nowrap", margin: "0" }}>
                  {strings[pageTitle][language].DayTotalTime} <br></br>
                  <span
                    style={{
                      display: "blocking",
                      whiteSpace: "nowrap",
                      margin: "0",
                      textAlign: "right",
                      lineHeight: "0.75rem"
                    }}
                  ></span>
                </p>
              </div>
              <h5 className="total-duration">
                {formatDuration(totalDurations)}
              </h5>
            </div>
          )}
        </div>
        {jiraUrl && tenantSettings?.jiraSettingDto?.isJira && (
          <div className="d-flex align-items-start gap-2 pe-5 ">
            <p
              style={{ whiteSpace: "nowrap", margin: "10" }}
              className="main-content__title"
            >
              {"Ticket URL: "}
            </p>
            <a
              href={jiraUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "var(--accent-color)", textDecoration: "none" }}
            >
              {jiraTicketNumber != "0000000" ? jiraPrefix + "-" + jiraTicketNumber : "Create New"}
            </a>
          </div>
        )}
        <div style={{ borderBottom: "1px solid black", margin: "1em" }}></div>
        <table
          style={{ boxSizing: "content-box", margin: "2em" }}
          className="activity-table"
        >
          <thead>
            <tr className="tr-grid">
              <th scope="col"></th>
              <th scope="col">{strings[pageTitle][language].ActivityType}</th>
              <th scope="col">{strings[pageTitle][language].Service}</th>
              <th scope="col">{strings[pageTitle][language].FormAct}</th>
              <th scope="col">{strings[pageTitle][language].PhoneNum}</th>
              <th scope="col">{strings[pageTitle][language].INFO}</th>
              <th scope="col">{strings[pageTitle][language].Line}</th>
              <th scope="col">{strings[pageTitle][language].Billable}</th>
              <th scope="col">{strings[pageTitle][language].Time}</th>
              <th scope="col">{strings[pageTitle][language].Duration}</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <div>
              {runningForms &&
                runningForms.map((process, index) => (
                  <FormRowData
                    showSuccessMessage={showSuccessMessage}
                    sendParentElapsedTime={(childElapsedTime) => {
                      setTotalDurations(totalDurations + childElapsedTime);
                      handleCallDuration(childElapsedTime);
                    }}
                    process={process}
                    key={process.processId}
                    handleEndTime={handleEndTime}
                    isRunning={true}
                    swapCurrentRunning={(formId) => swapCurrentRunning(formId)}
                    pauseFunc={(processDetails) =>
                      newPauseCurrentProccess(false, processDetails)
                    }
                    resumeFunc={resumeProcess}
                    handleFetchProcesses={handleFetchAllProcesses}
                    processDataCache={processDataCache}
                    setProcessDataCache={setProcessDataCache}
                    setRunningCallProcessDetails={setRunningCallProcessDetails}
                    ongoingCallBool={ongoingCallBool}
                  />
                ))}
            </div>
            <div>
              {filterRistrictedForms(historyForms).map((process, index) => (
                <FormRowData
                  showSuccessMessage={showSuccessMessage}
                  sendParentElapsedTime={(childElapsedTime) => {
                    // setTotalDurations(totalDurations + childElapsedTime)
                  }}
                  process={process}
                  key={process.processId}
                  isRunning={false}
                  handleEndTime={handleEndTime}
                  swapCurrentRunning={(formId) => swapCurrentRunning(formId)}
                  pauseFunc={(processDetails) =>
                    newPauseCurrentProccess(false, processDetails)
                  }
                  resumeFunc={resumeProcess}
                  handleFetchProcesses={handleFetchAllProcesses}
                  isRestricted={tenantSettings.isRestrictedMode}
                  processDataCache={processDataCache}
                  setProcessDataCache={setProcessDataCache}
                  {...(index === 0 && {
                    expandedProcess:
                      process.processType.processTypeId == 1 ? false : true
                  })}
                  ongoingCallBool={false}
                />
              ))}
            </div>
          </tbody>
        </table>
        <div style={{ borderBottom: "1px solid black", margin: "1em" }}></div>
      </div>
      {conversationData &&
        conversationData?.calls?.at(-1)?.state == "alerting" && (
          <div
            className={
              "slider d-flex flex-column align-items-center gap-2 justify-content-evenly"
            }
          >
            <h5 style={{ color: "white" }}>
              {" "}
              <FaPhoneVolume /> {strings["FormRowData"][language].InCall}
            </h5>
            <div
              className="d-flex gap-5 justify-content-between"
              style={{ width: "25%" }}
            >
              <div>
                <h6>{strings[pageTitle][language].PhoneNum}</h6>
                {/* <p>{conversationData.address}</p> */}
                <p>{inboundCallingNumber}</p>
              </div>
              <h6>LINE</h6>
              <p>{inboundQueueCalledName}</p>
            </div>
          </div>
        )}
    </div>
  );
};

export default FormsView;
